// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ResourcesConfig } from '@aws-amplify/core';

import { EnvForIndex } from '../../../shared/consts';

const env4index: EnvForIndex = JSON.parse('{"userPoolId":"ap-northeast-1_6vbKjUdW0","userPoolClientId":"6ejqcppenna8bjpivm4r1ei31m","identityPoolId":"ap-northeast-1:2f05214e-5ec1-47af-bfd5-3ab4f71f378c","wssApiEndpoint":"https://3xg85128jj.execute-api.ap-northeast-1.amazonaws.com/prod"}');

export const environment = {
  production: false,
  aws: {
    apiVersion: 'latest',
  },
  amplify: {
    Auth: {
      Cognito: {
        identityPoolId: env4index.identityPoolId,
        userPoolId: env4index.userPoolId,
        userPoolClientId: env4index.userPoolClientId,
      },
    },
  } as ResourcesConfig,
  wss: {
    apiEndpoint: env4index.wssApiEndpoint,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
